import { DataTable } from '@components/dataTable';
import { TdsMerchant } from '@root/globalTypes';
import { ColumnDef } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type TdsMerchantsTableProps = {
  data: TdsMerchant[];
  onRowSelect: (id: string) => void;
  onLinkedMerchantSelect: (id: string) => void;
};

export function useTdsMerchantsTable({
  data,
  onRowSelect,
  onLinkedMerchantSelect,
}: TdsMerchantsTableProps) {
  const { t } = useTranslation('app');

  const columns: ColumnDef<TdsMerchant>[] = [
    {
      id: 'name',
      accessorKey: 'name',
      header: t('table.name'),
      enableSorting: false,
    },
    {
      id: 'acquirer_name',
      accessorKey: 'acquirerName',
      header: t('table.acquirer'),
      enableSorting: false,
    },
    {
      id: 'cardtype',
      accessorKey: 'cardtype',
      header: t('table.scheme'),
      enableSorting: false,
    },
    {
      id: 'merchant_identifier',
      accessorKey: 'merchantIdentifier',
      header: t('table.merchantIdentifier'),
      enableSorting: false,
    },
    {
      id: 'active',
      accessorKey: 'active',
      header: t('table.status'),
      enableSorting: false,
    },
    {
      id: 'merchant',
      accessorKey: 'merchant',
      header: t('table.linkedMerchant'),
      enableSorting: false,
      cell: ({ row }): ReactNode => {
        const { merchant } = row.original;
        if (!merchant) return t('table.notLinked');
        return (
          <button
            type="button"
            className="text-primary underline"
            onClick={() => onLinkedMerchantSelect(merchant.merchantId)}>
            {merchant.name}
          </button>
        );
      },
    },
  ];

  return {
    columns,
    Table: () => {
      return (
        <DataTable
          columns={columns}
          data={data}
          selectionCallback={(row) => onRowSelect(row.original.id)}
        />
      );
    },
  };
}
